import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function WineIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M6.64258 9.99936V12.9994C6.64258 17.7994 10.2426 21.7594 14.8026 22.3594V24.1594L10.4826 28.2394C10.1226 28.5994 10.0026 29.0794 10.2426 29.5594C10.3626 30.0394 10.8426 30.2794 11.3226 30.2794H20.6826C21.1626 30.2794 21.6425 30.0394 21.7625 29.5594C21.8825 29.0794 21.8826 28.5994 21.5226 28.2394L17.2025 24.1594V22.3594C21.7625 21.7594 25.3625 17.7994 25.3625 12.9994V9.99936V4.59935C25.3625 3.03935 24.1626 1.83935 22.6026 1.83935H9.40258C7.84258 1.83935 6.64258 3.03935 6.64258 4.59935V9.99936ZM9.04258 4.59935C9.04258 4.35935 9.16258 4.23935 9.40258 4.23935H22.6026C22.8426 4.23935 22.9626 4.35935 22.9626 4.59935V8.07936C20.0826 7.11936 17.3226 8.19936 14.9226 9.15936C12.2826 10.2394 10.6026 10.8394 9.04258 9.51936V4.59935Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
